var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPartnerFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    draggable: "false",
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 6.0004C36 2.8476 33.1536 0 30 0H6C2.8464 0 0 2.8476 0 6.0004V29.9996C0 33.1524 2.8464 36 6.0004 36H18V22.4H13.6V16.4H18V14.0624C18 10.0308 21.0272 6.4 24.75 6.4H29.6V12.4H24.75C24.2192 12.4 23.6 13.0444 23.6 14.0096V16.4H29.6V22.4H23.6V36H30C33.1536 36 36 33.1524 36 29.9996V6.0004Z",
    fill: "#898989"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartnerFacebook);
export default __webpack_public_path__ + "static/media/partner-facebook.63cbf45d.svg";
export { ForwardRef as ReactComponent };